// import React, { useState } from 'react'
// import NavbarContainer from '../Components/NavbarContainer/NavbarContainer'
// import Lessonobjectives from '../Components/Lessonobjectives/Lessonobjectives'
// import BoxContainer from '../Components/BoxContainer/BoxContainer'
// import { useParams } from 'react-router-dom'
// import { Container } from 'react-bootstrap'
// import { data } from "../Lessons"
// import img12 from "../assets/1.2.png"
// import img13 from "../assets/1.3.png"
// import img14 from "../assets/1.4.png"
// import { useDispatch, useSelector } from 'react-redux'
// import CustomVedio from '../Components/CustomVedio/CustomVedio'
// import { apiUrl } from '../constant/apiUrl'
// import axios from 'axios'
// import { addAnswer } from '../hook/AnswersCourses'


// function Course() {

//   const { id } = useParams();
//   const { courses } = useSelector((state) => state);
//   const { auth } = useSelector((state) => state);
//   const token = auth.access_token; // Assuming token is stored in auth slice
//   const courseData = courses?.list.find((item) => item?.id == id)
//   const [loading, setLoading] = useState(false)
// const dispatch=useDispatch()
//   return (
//     <div>
//       <NavbarContainer />
//       <Container>
//         <h5 className='text-right mt-4 text_main'>{courseData?.title}</h5>
//         {courseData?.description?.map((item) => {
//           console.log(item);

//           return (
//             <>
//               <BoxContainer
//                 title={item?.title}
//                 data={item?.description}
//                 mainTitle={item?.mainTitle}
//                 img={item?.image}
//                 id={id}

//               />
//             </>
//           )
//         })}
//         <div className='lesson_objectives p-4 mb-4'>

          // <CustomVedio
          //   questions={courseData?.questions}
          //   videoPath={courseData?.survey_file}
          // />
//         </div>
//         <div className='lesson_objectives p-4 mb-4'>

//           {courseData?.questions.map((item, xindex) => {

//             return (
//               <div>
//                 <h6>{xindex + 1}{" "}{item?.question}</h6>
//                 <ul>
//                   {item.options.map((op, index) => {
//                     console.log(op?.id);

//                     return (
//                       <li className='py-2 option_answer'
//                         onClick={async () => {
//                           setLoading(true)

//                           try {
//                             const response = await axios.post(`${apiUrl}/courses/activity/submit-answer`, {
//                               "course_question_id": item?.id,
//                               "course_question_option_id": op?.id

//                             }, {
//                               headers: {
//                                 Authorization: `Bearer ${token}`,
//                               },
//                             });
//                             // setMessage("تم تسجيل الدخول بنجاح!");
//                             console.log(response.data.data);
//                             setLoading(false)
//                             const is_correctData = item.options.find((item) => item?.is_correct == 1)
//                             const isCorrect = is_correctData.option == op?.option ? 1 : 0;
//                                       dispatch(addAnswer({
//                             question: xindex + 1,   // ← رقم السؤال الصحيح
//                             is_correct: isCorrect,
//                             course: id
//                           }));
//                             if (is_correctData.option == op?.option) {

//                               alert("✅ إجابة صحيحة!");

//                             } else {

//                               alert(`❌ إجابة خاطئة. الإجابة الصحيحة هي: ${is_correctData.option}`);

//                             }



//                           } catch (error) {

//                             setLoading(false)


//                           }


//                         }}
//                       >{op?.option}</li>
//                     )
//                   })}
//                 </ul>
//               </div>
//             )
//           })}
//         </div>
//         {/* <Lessonobjectives/>
//   <LessonIntroduction/> */}
//       </Container>
//     </div>
//   )
// }

// export default Course

import React from 'react'
import NavbarContainer from '../Components/NavbarContainer/NavbarContainer'
import Lessonobjectives from '../Components/Lessonobjectives/Lessonobjectives'
import BoxContainer from '../Components/BoxContainer/BoxContainer'
import { useParams } from 'react-router-dom'
import { Container } from 'react-bootstrap'
import { data } from "../Lessons"
import img12 from "../assets/1.2.png"
import img13 from "../assets/1.3.png"
import img14 from "../assets/1.4.png"
import img21 from "../assets/16819581930.jpg"
import img22 from "../assets/images.png"
import img23 from "../assets/23.jpg"
import img33 from "../assets/33.png"
import img31 from "../assets/31.png"
import img41 from "../assets/41.jpg"
import img42 from "../assets/42.png"
import img51 from "../assets/51.png"
import img52 from "../assets/52.png"
import img53 from "../assets/53.png"
import { useSelector } from 'react-redux'
import CustomVedio from '../Components/CustomVedio/CustomVedio'


function Course() {

  const { id } = useParams();    
  const { courses } = useSelector((state) => state);
const courseInfo = courses.list.find((item) => item?.id == id);

  // const title = id == 1 ? "مهارة الأمان الرقمي " : id == 2 ? "التواصل الرقمي المسؤول" : id == 3 ? "المسؤولية الرقمية" : id == 4 ? "مهارة الوصول الرقمي " : "السلوك الرقمي ";
  const coursesData = id == 1 ? [
    {
      data: `
      🔹       أن يعرّف مفهوم الأمان الرقمي
      🔹 أن يميّز بين السلوك الآمن وغير الآمن في الفضاء الرقمي
    🔹 أن يُطبق ممارسات الأمان الرقمي في بيئة مركز مصادر التعلم
       `,
      title: "أهداف الدرس"
    },
    {
      data: `
      يعتبر أمن المعلومات في الوقت الراهن من الركائز الأساسية لتحقيق استقرار المجتمعات، حيث يسهم بشكل كبير في دعم الاقتصاد الوطني وتنمية الدول التي تعتمد بشكل أساسي على التكنولوجيا. فهو يمثل العمود الفقري لنهضة تكنولوجيا المعلومات والاتصالات التي تعتمد عليها المؤسسات على الصعيدين الداخلي والخارجي. وفي هذا السياق، أصبحت مسألة الأمن السيبراني من أبرز التحديات الإقليمية والعالمية، خاصة مع تزايد التهديدات الأمنية الإلكترونية، سواء من حيث عدد الهجمات أو حجم الأضرار الناتجة عنها.
       `,
      title: "مقدمة الدرس",
      img: img12
    },
    {
      data: `
حماية البيانات الشخصية من المخاطر التي قد تؤدي إلى سرقة الهوية أو التعرض للابتزاز والاحتيال.
توخي الحذر واليقظة أثناء استخدام التطبيقات ومواقع التواصل الاجتماعي المختلفة لضمان الأمان الرقمي.
التعرف على الأساليب الفعّالة للتصدي للشائعات والتعامل مع الحملات الإلكترونية الموجهة والجيوش الرقمية بشكل واعٍ ومسؤول.
التعرف على آليات حجب المواقع غير الآمنة التي تشكل تهديدًا على الخصوصية الشخصية أو أمن الدولة.

            `,
      title: "أبرز التهديدات الرقمية ",
      img: img13
    },
    {
      data: `
استخدم كلمات مرور قوية ومعقدة (وتغيّرها بشكل دوري).
لا تفتح أي رابط مشبوه أو بريد من جهة غير معروفة.
فعّل خاصية التحقق بخطوتين (2FA) في حساباتك.
قم بتحديث برامجك وأنظمتك باستمرار.
استخدم برامج حماية أصلية (Antivirus + Firewall).
احذر من تخزين ملفات الطلاب أو المدرسة على جهازك الشخصي.
استخدم النسخ الاحتياطي للملفات المهمة بانتظام.

            `,
      title: "استراتيجيات لحماية نفسك  ",
      img: img14
    },

    {
      data: `Video`,
      title: "النشاط التفاعلي  ",
      questions: data[0].questions,
      videoPath: data[0].video
    },
    {
      data: `activt`,
      title: "النشاط",
      questions: data[0].questions,
    },

  ] : id == 2 ? [
    {
      data: `      أن يُعرّف المتدرب مفهوم التواصل الرقمي المسؤول وأهميته في البيئة التعليمية.
أن يُميّز بين أمثلة للتواصل الرقمي الإيجابي والسلبي في مواقف عملية.
أن يتجنب السلوكيات الخاطئة أثناء التفاعل عبر الإنترنت، ويلتزم بآداب التعامل الرقمي.
  `,
      title: "أهداف الدرس",
      img:img21
    },
    {
      data: `التواصل الرقمي المسؤول هو الاستخدام الواعي والمهذب لأدوات الاتصال الإلكترونية بما يضمن احترام القوانين والأعراف، وصون حقوق الآخرين، وتحقيق التفاعل الإيجابي عبر الفضاء الرقمي.وتكمن أهميته في:
تعزيز الثقة بين أفراد المجتمع التعليمي.
الحد من النزاعات أو إساءة الفهم عبر الرسائل والمنشورات.
بناء صورة مهنية إيجابية للأخصائي أمام الطلاب والزملاء.
المساهمة في نشر ثقافة رقمية قائمة على الاحترام والمسؤولية.`,
      title: "التواصل الرقمي المسؤول وأهميته",
      img:img22
    },
    {
      data: `التواصل الرقمي الإيجابي: يتمثل في استخدام لغة واضحة ومهذبة، الرد في الوقت المناسب، مشاركة محتوى نافع وموثوق، احترام الخصوصية، وتقديم النقد بأسلوب بنّاء.
التواصل الرقمي السلبي: يشمل استخدام لغة جارحة أو ساخرة، تجاهل الرسائل الهامة، نشر شائعات أو معلومات مضللة، مشاركة بيانات أو صور دون إذن، والمبالغة في استخدام الرموز أو التعليقات غير اللائقة`,
      title: "المصطلحات"
    },
    {
      data: `التفكير قبل النشر أو المشاركة والتأكد من صحة المعلومة.
عدم مشاركة كلمات المرور أو البيانات الشخصية.
تجنّب الردود الانفعالية أو المسيئة في النقاشات.
احترام خصوصية الآخرين وعدم مشاركة محتوياتهم دون إذن.
الالتزام باستخدام أسلوب مهني في جميع المراسلات الرسمية.
`,
      title: "لتجنّب السلوكيات الخاطئة في التفاعل عبر الإنترنت، ينبغي على المتدرب:",
      img:img23
    },

    {
      data: `Video`,
      title: "النشاط التفاعلي  ",
      questions: data[1].questions,
      videoPath: data[1].video
    },
    {
      data: `activt`,
      title: "النشاط",
      questions: data[1].questions,
    },

  ] : id == 3 ? [
    {
      title: "أهداف الدرس",
      data: `             أن يُعرّف المتدرب مفهوم المسؤولية الرقمية وأهميتها في المجتمع التعليمي.
أن يُحلل المتدرب مواقف مرتبطة باستخدام غير مسؤول للمعلومات الرقمية.
أن يُطبق المتدرب سلوكيات صحيحة تعكس التزامه بالقوانين والحقوق الرقمية.   `,
img:img31

    }, {
      title: `المصطلحات`,
      data: `المسؤولية الرقمية تعني الالتزام بالقيم الأخلاقية والقوانين أثناء استخدام التكنولوجيا، بما يضمن احترام حقوق الآخرين وصون البيانات والمحتويات الرقمية.وتبرز أهميتها في:
الحفاظ على السمعة الرقمية للفرد والمؤسسة.
حماية حقوق الملكية الفكرية عند استخدام أو نشر المعلومات.
الحد من انتشار الأخبار الكاذبة أو المحتويات المضللة.
المساهمة في بناء مجتمع رقمي واعٍ ومتوازن.
`
    }, {
      title: `تطبيق سلوكيات صحيحة ومسؤولة`,
      data: `الالتزام بذكر المصادر عند استخدام أي محتوى رقمي
احترام حقوق التأليف والنشر وعدم انتهاكها
مراجعة دقة وصحة المعلومات قبل مشاركتها..
الالتزام بسياسات وقوانين استخدام الإنترنت داخل المدرسة.
أن يكون الأخصائي قدوة في توعية الطلاب بحقوقهم وواجباتهم الرقمية.`,
img:img33
    },
    {
      data: `Video`,
      title: "النشاط التفاعلي  ",
      questions: data[2].questions,
      videoPath: data[2].video
    },
    {
      data: `activt`,
      title: "النشاط",
      questions: data[2].questions,
    },
  ] : id == 4 ? [
    {
      title: "مهارات الدرس",
      data: `أن يُعرَّف مفهوم الوصول الرقمي وأبعاده.
أن تُوضَّح التحديات المرتبطة بعدم تكافؤ فرص الوصول إلى التكنولوجيا.
أن تُطبَّق ممارسات تسهم في تعزيز مبدأ تكافؤ الفرص الرقمية في بيئة التعلم.`,
img:img41
    },
    {
      title: `المصطلحات`,
      data: `الوصول الرقمي هو إتاحة التكنولوجيا والمصادر الرقمية للجميع بشكل عادل وشامل.ويتضمن:
إتاحة الأجهزة والإنترنت للجميع.
توفير موارد تعليمية إلكترونية قابلة للوصول (مثل ملفات ميسّرة لذوي الإعاقة البصرية أو السمعية).
إزالة العوائق التقنية التي تمنع بعض الفئات من المشاركة الفعالة.        `,
img:img42
    }
    , {
      title: `التحديات المرتبطة بعدم تكافؤ الوصول`,
      data: `الفجوة الرقمية بين الطلاب في المدن والقرى.
ضعف الاتصال بالإنترنت أو ارتفاع تكلفته.
نقص الأجهزة الحديثة لدى بعض الفئات.
غياب المحتوى المناسب لذوي الاحتياجات الخاصة.
`
    },

    {
      title: `ممارسات لتعزيز الوصول الرقمي`,
      data: `تهيئة منصات التعليم الإلكتروني بحيث تدعم الوصول لذوي الإعاقة (مثل قارئ الشاشة أو الترجمة النصية).
توفير معامل حاسوب مجهزة لجميع الطلاب في المدارس.
تصميم موارد تعليمية بأكثر من صيغة (نص، صوت، فيديو).
تعزيز ثقافة "التكنولوجيا للجميع" كجزء من قيم المواطنة الرقمية.
إن الوصول الرقمي يمثل البوابة الحقيقية للمواطنة الرقمية. فمن دون ضمان وصول عادل للتكنولوجيا، يبقى الحديث عن المشاركة الرقمية أو حماية الحقوق ناقصًا. لذلك، يُعدّ الوصول الرقمي ركيزة أساسية لتحقيق المساواة والعدالة داخل المجتمع التعليمي.
`
    },
    {
      data: `Video`,
      title: "النشاط التفاعلي  ",
      questions: data[3].questions,
      videoPath: data[3].video
    },
    {
      data: `activt`,
      title: "النشاط",
      questions: data[3].questions,
    },
  ] : [
    {
      title: "مهارات الدرس",
      data: `أن يُعرَّف مفهوم السلوك الرقمي وأهميته في الفضاء الإلكتروني.
أن تُميَّز الفروق بين السلوكيات الرقمية الصحيحة وغير الصحيحة.
أن تُطبَّق آداب التعامل في البيئات الرقمية بما يحقق الاحترام والمسؤولية.`,
img:img51
    },
    {
      title: "مقدمة الدرس",
      data: `  مع توسع استخدام المنصات الرقمية ووسائل التواصل، أصبح السلوك الرقمي عنصرًا أساسيًا في تحديد صورة الفرد وسمعته داخل المجتمع الرقمي. السلوك الرقمي هو مرآة للأخلاقيات والقيم التي يلتزم بها الشخص عند تفاعله عبر الإنترنت، سواء في بيئة تعليمية أو مهنية أو اجتماعية. إن التزام الجميع بآداب التعامل الرقمي يسهم في خلق فضاء إلكتروني آمن، محترم، وعادل.
السلوك الرقمي هو مجموعة القواعد والآداب الأخلاقية التي تنظّم تفاعل الأفراد عبر الإنترنت، بما يضمن أن يكون التواصل راقيًا، خاليًا من الإساءة، ومبنيًا على الاحترام المتبادل.وتكمن أهميته في:
تعزيز بيئة تعليمية آمنة.
الحد من التنمّر أو الإساءة الرقمية.
تحسين جودة التفاعل بين المعلمين والطلاب.
حماية سمعة الفرد والمؤسسة التعليمية.`
    }, {
      mainTitle: "الفروق بين السلوكيات الصحيحة وغير الصحيحة",
      title: "أولا : السلوكيات الصحيحة",
      data: `استخدام لغة مهذبة ومهنية في المراسلات.
احترام آراء الآخرين حتى في حالة الاختلاف.
الالتزام بالصدق عند نشر المعلومات.
الاستئذان قبل مشاركة بيانات أو صور تخص الآخرين.`,
img:img53

    }, {
      title: "ثانيا : السلوكيات غير الصحيحة",
      data: `استخدام ألفاظ جارحة أو ساخرة.
نشر إشاعات أو محتويات مضللة.
الاستهزاء بآراء الآخرين أو إقصاؤهم.
إرسال رسائل في أوقات غير مناسبة`,
img:img52
    }, {
      title: "",
      data: `تطبيق آداب التعامل في البيئات الرقمية
الالتزام بالتحية والختام المناسب في الرسائل الرسمية.
ضبط الانفعالات وتجنّب الرد أثناء الغضب.
استخدام الرموز التعبيرية والاختصارات بشكل معتدل ومناسب للسياق.
التعامل مع المنصات التعليمية باعتبارها امتدادًا للصف الدراسي الحقيقي.
أن يكون الشخص قدوة في نشر ثقافة الاحترام والمسؤولية عبر الإنترنت.
`
    }, {
      title: "تعريف السلوك الرقمي ",
      data: `من خلال ذلك نستنتج أن السلوك الرقمي هو حجر الأساس في بناء مجتمع إلكتروني قائم على الاحترام والتعاون. فالبيئة الرقمية لا تختلف عن الواقع، وما يُكتب أو يُنشر يظل أثره طويلًا. ومن خلال الالتزام بآداب التعامل عبر الإنترنت، يتحقق التوازن بين الحرية والمسؤولية، ويُسهم في تعزيز قيم المواطنة الرقمية.`
    },
    {
      data: `Video`,
      title: "النشاط التفاعلي  ",
      questions: data[4].questions,
      videoPath: data[4].video
    },
    {
      data: `activt`,
      title: "النشاط",
      questions: data[4].questions,
    },
  ]
  return (
    <div>
      <NavbarContainer />
      <Container>
        <h5 className='text-right mt-4 text_main'>{courseInfo?.title}</h5>
        {courseInfo?.description.map((item) => {
          console.log(courseInfo?.survey_file);
          
          return (
            <>
              <BoxContainer
                title={item?.title}
                data={item?.description}
                questions={courseInfo?.questions}
                videoPath={courseInfo?.survey_file}
                mainTitle={item?.mainTitle}
                img={item?.image}

              />
            </>
          )
        })}
                  <CustomVedio
            questions={courseInfo?.questions}
            videoPath={courseInfo?.survey_file}
          />
        <Lessonobjectives questions={courseInfo?.questions}/>
  {/* <LessonIntroduction/> */}
      </Container>
    </div>
  )
}

export default Course